new Freezeframe();

const sourceMenu = document.querySelector('#product-secondary-menu');
const innerMenu = document.querySelector('#product-secondary-menu-inner');
if(sourceMenu != null) {
  document.querySelectorAll('#product-secondary-menu a[href^="#"]').forEach(anchor => {
      var targetName = anchor.getAttribute('href').replace('#','');  
      
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
  
          if(targetName == "menu-trigger") {
            if(innerMenu.classList.contains("menu-open")) {
              innerMenu.classList.remove("menu-open");
            } else {
              innerMenu.classList.add("menu-open");
            }
          } else {
            document.querySelector('a[name="' + targetName + '"]').scrollIntoView({
                behavior: 'smooth'
            });  

            if(innerMenu.classList.contains("menu-open")) {
              innerMenu.classList.remove("menu-open");
            }
          }
      });
  });
  
  // const menuTop = sourceMenu.getBoundingClientRect().top + window.pageYOffset;

  window.onscroll = function(){
    // console.log(menuTop);
    // if(sourceMenu.getBoundingClientRect().top <= 0){
    //     sourceMenu.classList.add("sticky-stuck");
    // } else {
    //     sourceMenu.classList.remove("sticky-stuck");
    // } 
    
    // if(window.pageYOffset <= menuTop){
    //     sourceMenu.classList.remove("sticky-stuck");
    // }
    
    document.querySelectorAll('.link-target').forEach(anchorTarget => {
      var targetName = anchorTarget.getAttribute('name').replace('#','');
      var sourceLink = document.querySelector('#product-secondary-menu a[href="#' + targetName + '"]').parentElement;
      var pastLinks = document.querySelectorAll('.past-link');
      var activeLink = pastLinks[pastLinks.length - 1];
      
      //TOP
      if(anchorTarget.getBoundingClientRect().top <= 100){
          sourceLink.classList.add("past-link");
          sourceLink.classList.remove("active-link");
            
          if (sourceLink = activeLink) {
            activeLink.classList.add("active-link");
          } 
      } else {
          sourceLink.classList.remove("past-link");
          sourceLink.classList.remove("active-link");
      }
    });
  }
}

var featuresLink = document.querySelectorAll('a[href="#features"]');
var featuresSection = document.getElementById("product-features-section");
var proTipsLink = document.querySelectorAll('a[href="#pro-tips"]');
var proTipsSection = document.getElementById("custom-pro-tips");
var whenToUseLink = document.querySelectorAll('a[href="#when-to-use"]');
var whenToUseSection = document.getElementById("custom-when-to-use-section");
var spreaderSection = document.getElementById("custom-spreader-settings");
var spreaderLink = document.querySelectorAll('a[href="#spreader-settings"]');
var faqsLink = document.querySelectorAll('a[href="#faqs"]');
var faqsSection = document.getElementById("custom-faq-section");
var reviewsSection = document.getElementById("stamped-main-widget");
var reviewsLink = document.querySelectorAll('a[href="#reviews"]');

if (featuresSection != null) {
  var hasContent = featuresSection.dataset.hasContent;
  
  if (hasContent == "false") {
      featuresLink[0].parentNode.classList.add("hidden");
  }
} else {
  if (featuresLink[0] != null) {
    featuresLink[0].parentNode.classList.add("hidden");
  }
}

if (proTipsSection != null) {
  var hasProTips = proTipsSection.dataset.hasTips;
  
  if (hasProTips == "false") {
      proTipsLink[0].parentNode.classList.add("hidden");
  }
} else {
  if (proTipsLink[0] != null) {
    proTipsLink[0].parentNode.classList.add("hidden");
  }
}

if (whenToUseSection != null) {
  var hasContent = whenToUseSection.dataset.hasContent;
  
  if (hasContent == "false") {
      whenToUseLink[0].parentNode.classList.add("hidden");
  }
} else {
  if (whenToUseLink[0] != null) {
    whenToUseLink[0].parentNode.classList.add("hidden");
  }
}

if (spreaderSection != null) {
  var hasSpreaderFile = spreaderSection.dataset.hasFile;
  
  if (hasSpreaderFile == "false") {
      spreaderLink[0].parentNode.classList.add("hidden");
  }
} else {
  if (spreaderLink[0] != null) {
    spreaderLink[0].parentNode.classList.add("hidden");
  }
}

if (faqsSection != null) {
  var hasFAQs = faqsSection.dataset.hasQuestions;
  
  if (hasFAQs == "false") {
      faqsLink[0].parentNode.classList.add("hidden");
  }
} else {
  if (faqsLink[0] != null) {
    faqsLink[0].parentNode.classList.add("hidden");
  }
}

if (reviewsSection != null) {
//   // var reveiewCount = reviewsSection;
//   // check if review count is greater than 0
  
//   if (reveiewCount == "false") {
//       reviewsLink[0].parentNode.classList.add("hidden");
//   }
} else {
  if (reviewsLink[0] != null) {
    reviewsLink[0].parentNode.classList.add("hidden");
  }
}


// ***** these currently do not work because stamped takes so long to load *****
// 
// 
// var stampedQuestions = document.getElementById("tab-questions");
// var stampedQuestionsLink = document.querySelectorAll('a[href="#faqs"]');
// if (stampedQuestions != null) {
//   var stampedQuestionsCount = spreaderSection.dataset.count;
// 
//   if (stampedQuestionsCount <= 0) {
//       stampedQuestionsLink[0].parentNode.classList.add("hidden");
//   }
// }
// 
// var stampedReviews = document.getElementById("tab-reviews");
// var stampedReviewsLink = document.querySelectorAll('a[href="#reviews"]');
// if (stampedReviews != null) {
//   var stampedReviewsCount = spreaderSection.dataset.count;
// 
//   if (stampedReviewsCount <= 0) {
//       stampedReviewsLink[0].parentNode.classList.add("hidden");
//   }
// }

// window.onscroll = function(){
//     //TOP
//     if(someElement.getBoundingClientRect().top <= 0){
//         console.log("TRIGGER: top of div reached.");
//     }
//     //BOTTOM
//     // if(someElement.getBoundingClientRect().bottom <= 0){
//     //     console.log("TRIGGER: bottom of div reached.");
//     // }
// }

// Handle Chat Button on hash links
window.addEventListener('hashchange', function () {
    let hash = window.location.hash;

    if (hash === '#open-chat') {
      // Open chat widget
      GorgiasChat.open();

      // Clear the hash
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }
});

// Custom Buy It Now Button
setTimeout(function () {
  const customButton = document.getElementById('custom-buy-now-button');
  const customButtonModal = document.getElementById('custom-buy-now-button-modal');
  const moreOptionsButton = document.querySelector('.shopify-payment-button__more-options');
  const buyNowButton = document.querySelector('shopify-buy-it-now-button');

  // If we have options besides the unbranded Buy Now button,
  // handle showing the custom button and the button press
  if (customButton !== null && moreOptionsButton !== null) {
     customButton.classList.remove('hide-payment-button');
     customButton.addEventListener('click', function (event) {
        event.preventDefault();      
        moreOptionsButton.click();
      }); 
  }
}, 500);

// Make footer links to external sites open in a new tab
const footerLinks = document.querySelectorAll('footer li a');

if (footerLinks !== null) {
  for (let i = 0; i < footerLinks.length; i++) {
    const isExternal = footerLinks[i].hostname !== window.location.hostname && footerLinks[i].hostname !== '';

    if (isExternal) {
      footerLinks[i].setAttribute('target', '_blank');
      footerLinks[i].setAttribute('rel', 'noopener');
    }
  }
}

// Custom Honeypot fields
setTimeout(() => {
  const honeypotFields = document.querySelectorAll('.form-scan input');
  console.log('honeypotFields:', honeypotFields);

  if (honeypotFields !== null) {
    // Loop fields for listeners
    honeypotFields.forEach(element => {
      // Disable autofill
      element.setAttribute('autofill', 'nope');

      // Get form
      const form = element.form;

      if (form !== null) {
        const action = form.action;
        const submit = form.querySelector('button.submit');

        // Check input
        element.addEventListener('input', function (e) {
          const value = e.target.value;

          // Validation
          if (value !== '') {
            form.removeAttribute('action');
            submit.setAttribute('disabled', true);
          } else {
            form.setAttribute('action', action);
            submit.removeAttribute('disabled');
          }
        });
      }
    });
  }
}, 500);
